import { memo } from 'react'
import { Box, Paper, Typography, Button } from '@mui/material'

/**
 * QuickActions component - Reusable quick actions section
 */
export const QuickActions = memo(({ title = 'Quick Actions', actions }) => {
  return (
    <Paper
      sx={{
        p: 4,
        borderRadius: 3,
        background: (theme) => theme.palette.background.paper,
        boxShadow: 2,
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        {actions.map((action, index) => (
          <Button
            key={action.label || action.path || index}
            variant={action.variant || 'contained'}
            size="large"
            startIcon={action.icon}
            onClick={action.onClick}
            sx={{
              px: 3,
              ...(action.variant === 'outlined' && {
                borderWidth: 2,
                '&:hover': { borderWidth: 2 },
              }),
              ...action.sx,
            }}
          >
            {action.label}
          </Button>
        ))}
      </Box>
    </Paper>
  )
})
